module.exports = __webpack_public_path__ + "img/gywm_banner.039cd1c0.png";